export const toFixed = (number, range = 2) => {
    if (number === null || number === undefined) return 0;
    if (Number.isInteger(Number(number))) return number;
    return Number(number).toFixed(range);
};
